import { LitElement, html, css, nothing, PropertyValues } from 'lit';
import { property, customElement } from 'lit/decorators.js';
import { debounce } from '../../../src/utils/helpers';
import { SvgIcons } from '../../voyage-svg-icons/src/voyage-svg-icons';
import { ItemType, SearchListCategory, TypeAHeadSelectEvent } from './types';
import "@maersk-global/mds-components-core/mc-radio";
import { vesselInfo } from '../../../src/models/types/voyage-schedules-model.types';
import "@maersk-global/mds-components-core/mc-pagination";
import "@maersk-global/mds-components-core";
import { VoyageImoModel } from '../../../src/models/voyage-imo-model';
import { VoyageImoEventNames } from '../../../src/models/voyage-imo-model-impl';


const MAX_PAGINATION_SIZE = 20;

@customElement('voy-vessel-search')
export class VoyVesselSearch extends LitElement {
    public static areVesselsLoaded: boolean = false
    @property({ attribute: false }) private _input: HTMLInputElement | null = null;
    @property({ type: Number, attribute: false }) private _listLength: number = 0;
    @property({ type: Number, attribute: false }) private _vesselListLength: number = 0;
    @property({ type: Number, attribute: false }) private _paginationLength: number = 0;
    @property({ type: Number, attribute: false }) private _selectedPaginationNumber: number = 1;
    @property({ type: Boolean, attribute: false }) private _showDropdown: boolean = false;
    @property({ type: String, attribute: false }) private _searchString: string = "";
    @property({ type: String, attribute: false }) private _selectedOption: string = SearchListCategory.ALL;
    @property({ type: Array, attribute: false }) private _shownListItems: Array<vesselInfo> = [];
    @property({ type: Array, attribute: false }) private _allItems: Array<vesselInfo> = [];
    @property({ type: Boolean }) private _clickHandlerForLoader: boolean = false;
    @property({ type: Boolean }) private _searchInProgress: boolean = false;
    @property({ type:Number })   private _currentItemIndex = 0;
    @property({ type:Boolean })   private _showSearch : boolean= true;
    @property({ type:Boolean })   private _showAnchorIcon : boolean= false;
    @property({ type: Array, attribute: false }) vessels: Array<vesselInfo> = [];

    constructor() {
        super();
        this.onInput = this.onInput.bind(this);
        this._getListLength = this._getListLength.bind(this);
        this._shuffleArray = this._shuffleArray.bind(this);
        this._renderList = this._renderList.bind(this);
        this._renderEmptyMessage = this._renderEmptyMessage.bind(this);
    }

    static get styles() {
        return [
            css`
            :host {
                position: relative;
                display: flex;
                flex-direction: row;
                column-gap: 16px;
                align-items: center;
                background: white;
                font-family: MaerskText;
            }
            .backdrop {
                display: none;
                position: fixed;
                width: 100vw;
                left: 0px;
                top: 0px;
                background-color: rgba(0, 0, 0, 0.3);
                z-index: -2;
            }
            .backdrop[show] {
                display: block;
            }
            label {
                height: 24px;
                line-height: 24px;
            }
            .input-container {
                position: relative;
                display: flex;
                flex-direction: row;
                align-items: center;
                column-gap: 8px;
                background-color: white;
                flex: 1 1 auto;
                background: white;
                box-shadow: 0 6px 8px -1px rgba(20, 20, 20, 0.25);
            }
            .input-container:focus-within {
                outline: none;
                box-shadow: 0px 4px 12px rgba(20, 20, 20, 0.06), 0px 2px 4px rgba(20, 20, 20, 0.1);
            }
            input {
                flex: 1 1 auto;
                border: none;
                font-family: MaerskText;
                font-size: 16px;
                line-height: 24px;
                letter-spacing: 0em;
                background: white;
            }
            input:focus,
            input:focus-visible {
                outline: none;
            }

            .search-input-container {
                display: block;
                position: relative;
                font-family: MaerskText;
                font-size: 14px;
                line-height: 16px;
                font-weight: 400;
                width: 100%;
            }
            
            input {
                width: 100%;
                height: 57px;
                padding: 16px 10px 16px 55px;
                box-sizing: border-box;
                border-radius: 5px;
                font-size: 14px;
            }
            input:focus,
            input:active {
                outline: none;
                box-shadow: none;
            }
            input::placeholder {
                color: var(--neutrals-grey-05, grey);
            }
            .options {
                margin-top: 0px;
                display: none;
                max-height: calc(100vh - 212px);
                overflow-y: auto;
                margin-bottom: auto;
            }
            .options-full {
                max-height: calc(100vh - 157px);
            }
            .options[show] {
                display: block;
                padding-inline-start: 0px;
            }
            .option {
                display: flex;
                justify-content: center;
                flex-direction: column;
                list-style: none;
                cursor: pointer;
                pointer-events: all;
                font-size: 14px;
                color: var(--neutrals-grey-02, grey);
                pointer-events: all;
                border-bottom: 1px solid var(--neutrals-grey-06);
                padding-right: 16px;
                padding-left: 18px !important;
                height: 63px;
            }
            .option-item{
                display:flex;
                justify-content:space-between;
            }
            .title {
                justify-content:space-between;
            }
            .icon {
                align-self: center;
            }
            .option h4 {
                margin: 0px;
                font-size: 14px;
                flex: 1 1 auto;
                color: var(--voyage-black);
                height: 20px;
                line-height: 16px;
                font-family: Maersk Text;

            }
            .option:hover {
                background-color: var(--neutrals-grey-08, grey);
            }
            .option:focus {
                background-color: var(--neutrals-grey-08, grey);
                outline: none;
            }

            .option.no-results h2,
            .option.no-results p {
                font-size: 14px;
                line-height: 20px;
                margin: 0;
            }
            .search-icon {
                position: absolute;
                left: 20px;
                top: 14px;
            }

            .search-icon svg{
                margin-left: -6px;
                border-radius: 50%;
                width: 20px;
                padding: 5px;
                background-color: #0ba1df;
            }

            .search-left-icon {
                position: absolute;
                right: 13px;
                top: 19px;
            }
            .sub-title {
                font-size: 12px;
                color: var(--neutrals-grey-04);
                margin: 0px;
            }
            .empty-message {
                border-top: 2px solid var(--neutrals-grey-06);
                padding:20px;
                font-size: 15px;
                color: var(--neutrals-grey-03);
                font-size: 15px;
                font-weight: var(--paragraph-weight, normal);
                line-height: 24px;
                text-align: center;
            }
            .dropdown {
                position: absolute;
                margin: 0;
                padding: 0;
                top: 56px;
                display: none;
                width: 100%;
                box-shadow: 1px 3px 10px 0px rgba(0,0,0,.2);
                background-color: var(--neutrals-grey-10, grey);
            }
            .dropdown[show] {
                display: block;
            }
            .pagination-container {
                display: flex;
                justify-content: space-evenly;
                align-items: center;
                width: 100%;
                height: 80px;
                border-top: 1px solid var(--neutrals-grey-06);
            }
            .pagination-container > span {
                cursor: pointer;
                width: 30px;
                height: 32px;
                border-radius: 3px;
            }
            .pagination-container > span[selected] {
                background: #00243D;
                color: #FFFFFF;
            }
            .spinner{
                position: fixed;
                left: 50%;
                top: 50px;
                background-color: rgba(255,255,255,0.8);
                margin: 0;
                padding: 16px;
            }
            .search-icon[showSearch] {
                height: 20px;
                box-shadow: 5px 5px 10px rgba(0, 0, 0, 0.5);
                border-radius: 50%;
                width: 20px;
                background-color: #0ba1df;
            }
            .search-icon[showSearch] svg{
                height: 22px;
                width: 22px;
            }
            `   
        ];
    }

    render() {
        // vesselsDataLoaded : Checking for vessel data , if it is loaded or not (useful for rendering loader)
        let vesselsDataLoaded = this._allItems && this._allItems.length > 0;
        VoyVesselSearch.areVesselsLoaded = this._allItems && this._allItems.length > 0;
        
        return html`
            <div class="backdrop" ?show=${this._showDropdown} @click=${this._closeDropdown}></div>
            <div class="input-container">
                <div class="search-input-container" @click=${() => {
                    if (!this._clickHandlerForLoader){
                        this._clickHandlerForLoader = true;
                    }
                }}>
                    <div class="search-icon" ?showSearch=${!this._showSearch} >
                        ${SvgIcons.customSearch}
                    </div>
                        ${this._showSearch ? 
                            html`<input 
                            type="text"
                            class="search-input"
                            placeholder="Enter vessel, IMO"
                            @focus=${() => this._onFocusHandler()}
                            @click=${() => this.setDropdownVisibility(true)}
                            >` 
                            : nothing
                        }
                        ${this._renderDropdown(vesselsDataLoaded)}
                </div>
                
            </div>
        `
    };

    private _onFocusHandler() {
        if(!this._showDropdown) {
            this.setDropdownVisibility(true);
            this._applySearch();
        }
    }

    private _renderDropdown(vesselsDataLoaded: boolean) {
        if (this._allItems.length > 0) {
            return html`
            <div class="dropdown" ?show=${this._showDropdown && vesselsDataLoaded && this._allItems.length>0} @mouseenter = ${()=> {
                this._showDropdown = true;
                }} >
                ${(!vesselsDataLoaded && !(this._allItems.length > 0))
                    ? (html`<div class="spinner"><mc-loading-indicator fit="large" label="Loading vessels"></mc-loading-indicator></div>`)
                    : nothing
                }
                ${this._renderList(this._selectedOption)} 
                
            </div>
           `
        }
        if(!(this._allItems.length > 0) && (this._searchString !== "")){
            return this._renderEmptyMessage();
        }
    }

    private _renderList(option: string){
        let listItems = this._allItems;

        return html`
        <ul class="options options-full" ?show=${listItems?.length > 0}>
            ${listItems.slice((this._selectedPaginationNumber - 1) * MAX_PAGINATION_SIZE, (this._selectedPaginationNumber) * MAX_PAGINATION_SIZE).map((option, i) => {
                if (option.name) return this._renderVessel(option);
            })}
             ${this._getListLength() > MAX_PAGINATION_SIZE ? (html `<div class="pagination-container">
                    <mc-pagination
                        totalpages=${this._paginationLength}
                        currentpage=${this._selectedPaginationNumber}
                        hiddenlabels
                        visiblepages="6"
                        fit="small"
                        @pagechange=${this._onPaginationChanged}
                    >
                    </mc-pagination>
                </div> `): nothing }
        </ul> 
    `
    }

    private _renderVessel(vessel: vesselInfo) {
        const title = vessel.name || "--";
        const subtitle = vessel.imo.toString();
        return this._renderListItem(ItemType.VESSEL, (e: Event) => this._onVesselSelect(e, vessel), title, subtitle);
    }

    private _renderListItem(type: ItemType, selectFn: Function, title: string, subtitle?: string) {
        const icon = SvgIcons.vesselListIcon;
        return html`
            <div class="option" tabindex="0">
                <div class="option-item" @click=${(e: Event) => selectFn(e)}>
                    <div class="title">                  
                        <h4>${title}</h4>
                        ${subtitle ? html`<p class="sub-title">${subtitle}</p>` : nothing}
                    </div>
                    <div class="icon">
                        <span >${icon}</span>
                    </div>
                </div>
            </div>
        `
    }

    private _onVesselSelect(e: Event, listItem: vesselInfo): void {

        const option = e.currentTarget as HTMLLIElement;
        this._input!.value = option.getAttribute("data-label") ?? ""

        const detail: TypeAHeadSelectEvent = {
            value: option.getAttribute("data-value")!,
            label: option.getAttribute("data-label")!,
            index: parseInt(option.getAttribute("data-index")!, 10)
        }

        VoyageImoModel!.imo = parseInt(listItem?.imo?.toString());

        this._input!.value = "";
        this._closeDropdown();
        VoyageImoModel!.dispatchEvent(
            new CustomEvent(VoyageImoEventNames.ImoUpdated),
        )
        this.requestUpdate()
    }

    private _renderEmptyMessage() {
        return html`
        <div class = "empty-message">
            Oops, looks like there’s no match for your search.
            <p>Please try again...</p>
        </div>`
    }

    private _onPaginationChanged(e: InputEvent) {
        const selectedPaginationNumber = e.detail;
        if (typeof selectedPaginationNumber === 'number' && selectedPaginationNumber >= 0) {
            this._selectedPaginationNumber = selectedPaginationNumber;
        }
    }

    private _getListLength() {
        return this._vesselListLength;
    }
 
    private _closeDropdown() {
        this._input!.value = "";
        this._showDropdown = false;
        this.reset();
    }

    private _setSearchString(val: string) {
        if (this._input) {
            this._searchString = val;
        }
    }

    private async _applySearch(): Promise<void> {
        const searchString = this._searchString || '';
        const allVessels = this.vessels;
        const filteredVessels = allVessels.filter((vessel: vesselInfo) => this.omniFilterVessel(searchString, vessel));
        if (filteredVessels) {
            this._applyFilterResult(filteredVessels);
        }
        this._searchInProgress = true;
    }

    private omniFilterVessel(searchString: string, vessel: vesselInfo): boolean {
        let showVessel = false;
        const searchWord = searchString.toLowerCase()
        // User text input
        const vesselName = vessel?.name || "";
        const imo = vessel?.imo ? vessel?.imo.toString() : '';
        const isNum = /^\d+$/.test(searchWord);
        showVessel = (
            (isNum && imo.toString().includes(searchWord)) ||
            vesselName.toLowerCase().includes(searchWord)
        );
        return showVessel;
    }

    private _shuffleArray() {
        // Shuffling the list or randomizing list with vessels data ;
        let shuffledArray = [];
        for (let i = 0; i < this._listLength; i++) {
            if (this._shownListItems[i]) shuffledArray.push(this._shownListItems[i]);
        }
        return shuffledArray;
    }

    private _applyFilterResult(vessels: any) {
        this._shownListItems = vessels;
        this._vesselListLength = this._shownListItems.length;

        this._listLength = this._getListLength()
        this._allItems = this._shuffleArray();


        this._paginationLength = Math.ceil(this._listLength / MAX_PAGINATION_SIZE);
        this._selectedPaginationNumber = 1;

        this._searchInProgress = false;
    }

    firstUpdated() {
        const input = this.shadowRoot!.querySelector("input");
        this._input = input;

        if (!this._input) return;
        this._input.addEventListener('input', debounce(this.onInput, 250));
    }
    
    updated(changedProperties: PropertyValues) {
        changedProperties.forEach((oldValue, propName) => {
            const input = this.shadowRoot!.querySelector("input");
            this._input = input;
    
            if (!this._input) return;
            if (propName === "_input"){
                this._input.addEventListener('input', debounce(this.onInput, 250));
            }
            if(this._searchString){
                this._showAnchorIcon = false        
            }
        });     
    }


    connectedCallback() {
        super.connectedCallback();
        const optionItems = this.shadowRoot!.querySelectorAll('.option');
        const input = this.shadowRoot!.querySelector("input");
        this._input = input;

        if (!this._input) return;

    }

    disconnectedCallback() {
        super.disconnectedCallback();
    }

    reset(): void {
        this._searchString = "";
        this._shownListItems = [];
        this._listLength = 0;

        this._selectedPaginationNumber = 1;
        this._paginationLength = 0

        this._allItems = [];
        this._selectedOption = SearchListCategory.ALL

        this.requestUpdate();
    }

    private setDropdownVisibility(show: boolean) {
        this._showDropdown = show;
    }

    onInput() {
        if(!this._input) return;
        this._setSearchString(this._input!.value);
        this._currentItemIndex = 0
        this._applySearch();
        const optionItems = this.shadowRoot!.querySelectorAll('.option');
    }
}
